import React, { useState, useEffect } from 'react';
import VenueMap from '../../components/Map/VenueMap';
import { supabase } from '../../services/supabaseClient';
import './VenueMapPage.css';

/**
 * VenueMapPage component
 * Displays venues and gigs on a map for artists to browse
 * Only accessible to logged-in users
 */
const VenueMapPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mapCenter] = useState(null);

  useEffect(() => {
    // Check if user is logged in
    const getSession = async () => {
      const { data } = await supabase.auth.getSession();
      setUser(data.session?.user || null);
      setLoading(false);
    };
    
    getSession();
  }, []);

  // If loading, show a loading message
  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading map...</p>
      </div>
    );
  }

  // If user is not logged in, show a message
  if (!user) {
    return (
      <div className="container mt-5">
        <div className="card">
          <div className="card-body text-center">
            <h5 className="card-title">Please Log In</h5>
            <p className="card-text">
              You need to be logged in to view the venue map.
            </p>
            <a href="/login" className="btn btn-primary">
              Log In
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid venue-map-page">
      <div className="row">
        <div className="col-12 mb-4">
          <h1>Venues & Gigs Map</h1>
          <p className="text-muted">
            Explore venues and upcoming gigs on the map. Click on a marker to see more details.
          </p>
        </div>
      </div>
      
      <div className="row">
        <div className="col-12 map-container">
          <VenueMap center={mapCenter} zoom={10} />
        </div>
      </div>
      
      <div className="row mt-4">
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">
                <i className="fas fa-building text-primary mr-2"></i> Venue Markers
              </h5>
              <p className="card-text">
                Venues are represented by building icons on the map. Click on a venue marker to see their profile and contact information.
              </p>
            </div>
          </div>
        </div>
        
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">
                <i className="fas fa-music text-success mr-2"></i> Gig Markers
              </h5>
              <p className="card-text">
                Gigs are represented by music note icons. Click on a gig marker to see details about the event, including date, time, and payment information.
              </p>
            </div>
          </div>
        </div>
        
        <div className="col-12 col-md-6 col-lg-4 mb-3">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">
                <i className="fas fa-info-circle text-info mr-2"></i> Privacy Notice
              </h5>
              <p className="card-text">
                This map only shows venue locations and gig locations. Artist locations are never displayed on maps to protect your privacy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueMapPage;
